<form [formGroup]="form" class="row">
  <div class="col-4">
    <mat-form-field class="mat-form-field-fluid" [formFieldState]="form.controls.building_name">
      <input matInput placeholder="Building ID" formControlName="building_name" />
      <mat-hint [formFieldHintState]="form.controls.building_name">
        Building ID <span>required</span>
      </mat-hint>
      <mat-error>
        Building ID <strong>required</strong>
      </mat-error>
    </mat-form-field>
  </div>

  <div class="col-4">
    <mat-form-field class="mat-form-field-fluid">
      <input matInput placeholder="Completion year(s)" formControlName="completion_year" />
    </mat-form-field>
  </div>
  
  <div class="col-4">
    <mat-form-field class="mat-form-field-fluid">
      <input matInput mask="0000" [validation]="false" placeholder="Total Building Floors"
        formControlName="floors" />
    </mat-form-field>
  </div>

  <div class="col-12">
    <mat-form-field class="mat-form-field-fluid">
      <textarea matInput rows="3" placeholder="Construction description"
        formControlName="construction_desc"></textarea>
    </mat-form-field>
  </div>

  <div class="col-4">
    <mat-form-field class="mat-form-field-fluid">
      <mat-select formControlName="main_wall_id" placeholder="Main Walls">
        <mat-option *ngFor="let item of mainwalls" [value]="item.id">
          {{ item.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="col-4">
    <mat-form-field class="mat-form-field-fluid">
      <mat-select formControlName="external_facade_id" placeholder="External Facade">
        <mat-option *ngFor="let item of externalFacades" [value]="item.id">
          {{ item.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="col-4">
    <mat-form-field class="mat-form-field-fluid">
      <mat-select formControlName="roof_covering_id" placeholder="Roof Coverings">
        <mat-option *ngFor="let item of roofCoverings" [value]="item.id">
          {{ item.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="col-4">
    <mat-form-field class="mat-form-field-fluid">
      <input matInput formControlName="size" placeholder="Size" 
        mask="separator.3" thousandSeparator="," />
    </mat-form-field>
  </div>

  <div class="col-4">
    <mat-form-field class="mat-form-field-fluid">
      <mat-select formControlName="size_unit_id" placeholder="Unit">
        <mat-option *ngFor="let item of unitAreaMeasurements" [value]="item.id">
          {{ item.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</form>